import axios from '@axios'
import ErrorMessage from '@core/utils/ErrorMessage'

export default class SettingsIntegrationsClient {
  constructor() {
    this.api = axios
    this.error = new ErrorMessage()
  }

  async getBlingAuthGetCode() {
    try {
      const { data } = await this.api.get('/bling/auth/getCode')
      return data
    } catch (error) {
      this.error.message(error)
    }
  }

  async postBlingAuthGetToken(code) {
    try {
      const { data } = await this.api.post(`/bling/auth/getAcessToken?code=${code}`)
      return data
    } catch (error) {
      this.error.message(error)
    }
  }

  async getIntegrationsVerifyByNome(nome) {
    try {
      const { data } = await this.api.get(`/integrations/verify/${nome}`)
      return data
    } catch (error) {
      this.error.message(error, 'Integração não encontrada')
    }
  }
}
